import DefaultAttr from './default'
export default class UrlPage extends DefaultAttr {
  urlValue = ''
  constructor (args = {}) {
    super(args)
    this._.assign(this, args)
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/urlPage.js